import React, { Component } from 'react';
import './assets/sass/pages/app.scss';

import Super from './components/hook/super/index';

import Normal from './components/hook/normal/index';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: 'super',
    };
  }

  componentDidMount() {
  }


  render() {

    const type = this.state.selected;

    const superImg = {
      backgroundImage: `url(${ type === 'super' ? require('./assets/img/super-selected.png') : require('./assets/img/super.png')})`,
      marginLeft: '-468px',
      cursor: `${ type === 'super' ? 'default' : 'pointer' }`,
    }
    const normalImg = {
      backgroundImage: `url(${ type === 'normal' ? require('./assets/img/normal-selected.png') : require('./assets/img/normal.png')})`,
      marginLeft: '100px',
      cursor: `${ type === 'normal' ? 'default' : 'pointer' }`,
    }
    return (
      <div id="hy_wrap">
        <div className='headImg'>
          <img src={require('./assets/img/head.png')}/>
          <div
            className='btn'
            style={ superImg }
            onClick={() => {
              this.setState({selected: 'super'})
            }
            }></div>
          <div
            className='btn'
            style={ normalImg }
            onClick={() => {
              this.setState({selected: 'normal'})
            }
            }></div>
        </div>
        <div className='mainContent'>
          {
            this.state.selected === 'super' &&
            <><Super /></>
            
          }
          {
            this.state.selected === 'normal' &&
            <><Normal /></>
          }
        </div>
      </div>
    );
  }
}

export default App;
